/**
 * Sort By Button Component
 *
 * Dropdown button for sorting product results.
 * Figma: Sort By Button (Node: 51:7212)
 *
 * Dimensions: 240px × 35px
 * Shows current sort option with dropdown arrow
 */
"use client";

import Image from "next/image";

import { colors } from "@/styles/design-tokens";

interface SortByButtonProps {
  currentSort?: string;
  onClick?: () => void;
  className?: string;
  isOpen?: boolean;
  dropdownId?: string;
}

export function SortByButton({
  currentSort = "Recommended",
  onClick,
  className = "",
  isOpen = false,
  dropdownId,
}: SortByButtonProps) {
  return (
    <button
      type="button"
      data-testid="sort-by-button"
      onClick={onClick}
      className={`inline-flex items-center justify-between transition-all hover:opacity-85 ${className}`}
      style={{
        backgroundColor: colors.background.white,
        width: "240px",
        height: "35px",
        borderRadius: "6px",
        border: `1px solid ${isOpen ? colors.stroke.softBlack : colors.divider.default}`,
        paddingLeft: "12px",
        paddingRight: "12px",
        paddingTop: "8px",
        paddingBottom: "8px",
        gap: "14px",
        boxShadow: isOpen
          ? "0px 12px 24px rgba(0, 0, 0, 0.12)"
          : "0px 4px 12px rgba(0, 0, 0, 0.04)",
        transition:
          "box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out, opacity 0.2s ease-in-out",
      }}
      aria-haspopup="listbox"
      aria-expanded={isOpen}
      aria-controls={dropdownId}
    >
      <span className="text-tag-caps text-ink flex-1 w-full text-left whitespace-nowrap overflow-hidden text-ellipsis">
        Sort By: {currentSort}
      </span>

      {/* Dropdown arrow - 14×14px pointing down */}
      <Image
        src="/icons/dropdown.svg"
        alt=""
        width={14}
        height={14}
        style={{
          flexShrink: 0,
          opacity: 0.65,
          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          transition: "transform 0.2s ease-in-out",
        }}
      />
    </button>
  );
}
